import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/employeeCategory/importer/employeeCategoryImporterSelectors';
import EmployeeCategoryService from 'src/modules/employeeCategory/employeeCategoryService';
import fields from 'src/modules/employeeCategory/importer/employeeCategoryImporterFields';
import {i18n} from 'src/i18n';

const employeeCategoryImporterActions = importerActions(
  'EMPLOYEE_CATEGORY_IMPORTER',
  selectors,
  EmployeeCategoryService.import,
  fields,
  i18n('entities.employeeCategory.importer.fileName'),
);

export default employeeCategoryImporterActions;
